// extracted by mini-css-extract-plugin
export default {"container":"Card_container__9xkEA","text":"Card_text__R-DzJ","truncate":"Card_truncate__geahs","imgCover":"Card_imgCover__ka7o-"};